{
  "login-secret-with-password-page": {
    "buttons": {
      "forgot-password": "Forgot password",
      "login": "Login",
      "set-password": "Set password",
      "update-password": "Update password"
    },
    "text": {
      "new-password": "Set your password",
      "new-password-hint": "Your password will be required for future logins",
      "password": "Password",
      "password-invalid": "Your password is incorrect. Please try again!",
      "password-hint": "Please enter your password to login",
      "update-password": "New password",
      "update-password-hint": "Please enter your new password",
      "your-password": "Your password"
    }
  }
}
